import { useQuery } from '@tanstack/react-query'
import { requestBusinessObjects } from 'shared/services'

import { useJWTToken } from 'App/Auth'

const checkPairedLogger = ({ queryKey: [
    _key, // eslint-disable-line no-unused-vars
    {
        id,
        loggerqrcode,
        token,
    },
] }) => {
    const escapedQrCode = encodeURIComponent(loggerqrcode)

    return requestBusinessObjects({
        method: 'GET',
        url: `skycenter/logger/loggerqrcode/${escapedQrCode}/ispaired/${id}`,
        token,
    })
        .then((data) => {
            return data.data
        })
}

function useCheckPairedLogger(id, loggerqrcode, enabled) {
    const token = useJWTToken()

    return useQuery({
        queryKey: [
            'checkPairedLogger',
            {
                id,
                loggerqrcode,
                token,
            },
        ],
        queryFn: checkPairedLogger,
        enabled,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 1000,
    })
}

export default useCheckPairedLogger
